import type { TypedDocumentNode } from '@apollo/client';
import gql from 'graphql-tag';

/**
 * Query for token ttl and remaining token ttl.
 */
export const getTokenInfo: TypedDocumentNode<GetTokenInfoResponse> = gql`
  query getTokenInfo {
    me {
      id
      remainingTokenTtl
      tokenTtl
      loginUrl
      assertions
    }
  }
`;

export interface GetTokenInfoResponse {
  me: {
    remainingTokenTtl: number;
    tokenTtl: number;
    loginUrl: string;
    assertions: string;
  };
}
